import Breadcrumb from "../components/Breadcrumb";
import PageNav from "../components/PageNav";
import data from "../content/Privacy.json";
import PageSection from "../components/PageSection";

const Policies = () => {
  return (
    <>
      <Breadcrumb
        title="Policy"
        items={[{ name: "Home", link: "/" }, { name: "Policies" }]}
      />
      <div className="max-w-7xl mx-auto mt-5 rounded-lg">
        <PageNav data={data} />
      </div>

      <PageSection data={data} />
    </>
  );
};

export default Policies;
